import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { isMobile, capitalizeAll, getCrossedBandFinder} from "../../../../utils";
import SVGInline from "react-svg-inline";
import { BAND, MUSICIAN } from '../../../../consts';

// svgs
import arrowSideSVG from "../../../inlineSVGs/arrowSideSVG";

import './BandFinderSlider.css';

class BandFinderSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

        this.subCatScrollerRef = {};
    }

    scrollSubCat(side) {
        if (!this.subCatScrollerRef) return;

        if (side === 'left') {
            this.subCatScrollerRef.scrollBy({
                top: 0,
                left: -300,
                behavior: 'smooth'
            });

            return;
        }

        if (side === 'right') {
            this.subCatScrollerRef.scrollBy({
                top: 0,
                left: 300,
                behavior: 'smooth'
            });
        }
    }

    renderCategories() {
        if (!this.props.datatypes.categories[this.props.type]) return null;

        const lookingForType = this.props.type === BAND ? MUSICIAN : BAND;

        const type = this.props.isCrossedLabels ? getCrossedBandFinder(this.props.type) : this.props.type;

        return (
            this.props.datatypes.categories[lookingForType].map((cat, index) => {
                return (
                    <div key={index}
                         className={`category ${type} ${this.props.selected.indexOf(cat.name) > -1 ? 'selected' : 'unselected'}`}
                         onClick={()=> this.props.handleClickItem(cat)}>
                        {capitalizeAll(cat.text)}
                    </div>
                )
            })
        )
    }

    render() {
        if (!this.props || !this.props.type || !this.props.datatypes) return null;

        return (
            <div className={`band-finder-slider-wrapper`} style={this.props.styles}>
                <div className={`categories-left-arrow ${isMobile() ? 'mobile' : ''}`} onClick={() => this.scrollSubCat('left')}>
                    <SVGInline className="arrow-side-icon" svg={arrowSideSVG} component="i"/>
                </div>
                <div className={`categories-right-arrow ${isMobile() ? 'mobile' : ''}`} onClick={() => this.scrollSubCat('right')}>
                    <SVGInline className="arrow-side-icon" svg={arrowSideSVG} component="i"/>
                </div>

                <div className="scroller" ref={ref => this.subCatScrollerRef = ref}>
                    {this.renderCategories()}
                </div>
            </div>
        )
    }
}

BandFinderSlider.propTypes = {
    datatypes: PropTypes.object,
    type: PropTypes.string,
    selected: PropTypes.array,
    handleClickItem: PropTypes.func,
    styles: PropTypes.object,
    isCrossedLabels: PropTypes.bool
};

export default BandFinderSlider;



// WEBPACK FOOTER //
// ./src/Components/Elements/Carousels/BandFinderSlider/BandFinderSlider.js